import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { duplicateCategory } from "../../services/categories";

interface IPayload {
    category_id: number;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
    successCallback: () => void;
};

interface IResponse {
    statusCode: number;
    message: string;
    error?: string;
};

const useDuplicateCategory = () => {
    const mutationFn = async (payload: IPayload) => {
        return await duplicateCategory(payload.category_id);
    };

    const queryClient = useQueryClient();


    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response.statusCode === 200) {
                variables.setIsProcessing(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                variables.successCallback();
                toast.success("Category duplicated successfully.");
            }
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message);
        },
        retry: 0,
    })
};

export default useDuplicateCategory;